import moment from "moment";

export default {
    namespaced: true,
    state : ()=>({
        namespaced: true,
        datavolo:null,
        numerovolo: null,
        tipoproblema: null,
        siglacarrier: '',
        compagnia: null,
        volichiusiok: false,
        datalimitata15ottobre2021:false,
        casistiche: [
            {"id":1, "desc":"RITARDO SUPERIORE ALLE 3 ORE"},
            {"id":2, "desc":"CANCELLAZIONE VOLO"},
            {"id":3, "desc":"SMARRIMENTO BAGAGLIO"},
            {"id":4, "desc":"OVERBOOKING"},
        ],
        preavvisi : [
            {"id":1, "desc":"Con oltre 14 giorni di preavviso"},
            {"id":2, "desc":"Con meno di 14 giorni di preavviso"},
            {"id":3, "desc":"Non ho ricevuto alcuna comunicazione"}
        ],
        preavviso:'',
        compagnie:[],
        informazioni: '',
        partenza:null,
        destinazione:null,
        partenzaFull:{},
        destinazioneFull:{},
        coincidenze: [],
        coincidenzepresenti : false,
        datariconsegnabagaglio : null,
        datacomunicazionecompagnia : null,
        nessunacomunicazione : false,
        bagagliononriconsegnato : false,
        datariprotezione: null,
    }),
        getters : {
            getNumeroVolo: (state)=>{
                return state.numerovolo;
            },
            getDataVolo: (state)=>{
                return state.datavolo;
            },
            getDataVoloFormattata: (state)=>{
                if(state.datavolo === undefined || state.datavolo === null || state.datavolo === '') return '';
                return moment(state.datavolo).format('DD/MM/YYYY');
            },
            getDataVoloFormattataISO: (state)=>{
                if(state.datavolo === undefined || state.datavolo === null || state.datavolo === '') return '';
                return moment(state.datavolo).format('YYYY-MM-DD');
            },
            getCompagnie: (state)=>{
                return state.compagnie;
            },
            getCompagnia: (state)=>{
                return state.compagnia;
            },
            getTipoProblema: (state)=>{
                return state.tipoproblema;
            },
            getDescTipoProblema: (state)=> id =>{
                if(id === undefined) return;

                let casi = JSON.parse(JSON.stringify(state.casistiche));
                return casi.find((comp)=>{
                    if(comp === undefined) return false;
                    return comp.id == id;
                });
            },
            getCodiceCompagnia:(state) => id =>{
                if(id === undefined) return;

                let comps = JSON.parse(JSON.stringify(state.compagnie));
                return comps.find((comp)=>{
                    if(comp === undefined) return false;
                    return comp.id == id;
                });

            },
            getCompagniaDaId:(state)=> id =>{
                if(id === undefined) return;

                let comps = JSON.parse(JSON.stringify(state.compagnie));
                return comps.find((comp)=>{
                    if(comp === undefined) return false;
                    return comp.id == id;
                });
            },
            getCodiceCompagniaSelezionata:(state)=>{
                let comps = JSON.parse(JSON.stringify(state.compagnie));
                let result = comps.find((comp)=>{
                    if(comp === undefined) return false;
                    return comp.id == state.compagnia;
                });

                if(result !== undefined) return result.codicecompagnia;
                return null;
            },
            getCasi: (state)=>{
                return state.casistiche;
            },
            getVoliChiusiOK: (state)=>{
                return state.volichiusiok;
            },
            getPartenza: (state)=>{
                return state.partenza;
            },
            getDestinazione:(state)=>{
                return state.destinazione;
            },
            getCoincidenzePresenti:(state)=>{
                return state.coincidenzepresenti;
            },
            getCoincidenze:(state)=>{
                return state.coincidenze;
            },
            getPreavvisi: (state)=>{
                return state.preavvisi;
            },
            getDataLimitataOttobre2021:(state)=>{
                return state.datalimitata15ottobre2021;
            },
            getDataComunicazione:(state)=>{
                return state.datacomunicazionecompagnia;
            },
            getDataRiconsegnaBagaglio:(state)=>{
                return state.datariconsegnabagaglio;
            },
            getNessunaComunicazioneRicevuta:(state)=>{
                return state.nessunacomunicazione;
            },
            getBagaglioNonRiconsegnato:(state)=>{
                return state.bagagliononriconsegnato;
            },
            getDataRiprotezione:(state)=>{
                return state.datariprotezione;
            }
        },

    actions : {
        commitNumeroVolo: (context,numerovolo)=>{
            context.commit('setNumeroVolo',numerovolo);
        },
        commitDataVolo: (context,datavolo)=>{
            context.commit('setDataVolo',datavolo);
        },
        commitCompagnia:(context,compagnia)=>{
            context.commit('setCompagnia',compagnia);
        },
        commitTipologiaProblema:(context,problema)=>{
            context.commit('setTipologiaProblema',problema);
        },
        commitSetCompagnie:(context,compagnie)=>{
            context.commit('setCompagnie',compagnie);
        },
        commitSetVoliChiusiOk:(context,stato)=>{
            context.commit('setVoliChiusiOK',stato)
        },
        commitSetInformazioni:(context,info)=>{
            context.commit('setInformazioni',info);
        },
        commitSetDestinazione:(context,destinazione)=>{
            context.commit('setDestinazione',destinazione);
        },
        commitSetPartenza:(context,partenza)=>{
            context.commit('setPartenza',partenza)
        },
        commitSetCoincidenzePresenti:(context,valore)=>{
            context.commit('setCoincidenzePresenti',valore);
        },
        commitSetCoincidenze:(context,array)=>{
            context.commit('setCoincidenze',array);
        },
        commitAddCoincidenze:(context,obj)=>{
            context.commit('addCoincidenze',obj);
        },
        commitDelCoincidenza:(context,index)=>{
            context.commit('delCoincidenza',index)
        },
        commitSetPreavviso:(context,preavviso)=>{
            context.commit('setPreavviso',preavviso);
        },
        commitDataLimitataOttobre2021:(context,value)=>{
            context.commit('setDataLimitataOttobre2021',value);
        },
        commitSetDataComunicazione:(context,value)=>{
            context.commit('setDataComunicazione',value);
        },
        commitSetDataRiconsegnaBagaglio:(context,value)=>{
            context.commit('setDataRiconsegnaBagaglio',value);
        },
        commitSetBagaglioNonRiconsegnato:(context,value)=>{
            context.commit('setBagaglioNonRiconsegnato',value);
        },
        commitSetNessunaComunicazione:(context,value)=>{
            context.commit('setNessunaComunicazione',value);
        },
        commitPulisciStato:(context)=>{
            context.commit('pulisciStato');
        },
        commitSetDataRiprotezione:(context,value)=>{
            context.commit('setDataRiprotezione',value);
        }
    },
    mutations : {
        setNumeroVolo: (state,numerovolo)=>{
            state.numerovolo = numerovolo;
        },
        setDataVolo: (state,datavolo)=>{
            state.datavolo = datavolo;
        },
        setCompagnia:(state,compagnia)=>{
            state.compagnia = compagnia;
        },
        setTipologiaProblema:(state,problema)=>{
            state.tipoproblema = problema;
        },
        setCompagnie:(state,compagnie)=>{
            state.compagnie = compagnie;
        },
        setVoliChiusiOK: (state,stato)=>{
            state.volichiusiok = stato;
        },
        setInformazioni:(state,info)=>{
            state.informazioni = info;
        },
        setPartenza:(state,partenza)=>{
            state.partenza = partenza;
        },
        setDestinazione:(state,destinazione)=>{
            state.destinazione = destinazione
        },
        setCoincidenzePresenti:(state,valore)=>{
            state.coincidenzepresenti = valore;
        },
        setCoincidenze:(state,array)=>{
            state.coincidenze = array;
        },
        addCoincidenze:(state,obj)=>{
            state.coincidenze.push(obj);
        },
        delCoincidenza:(state,index)=>{
            state.coincidenze.splice(index,1);
        },
        setPreavviso:(state,preavviso)=>{
            state.preavviso = preavviso;
        },
        setDataLimitataOttobre2021:(state,value)=>{
            state.datalimitata15ottobre2021 = value;
        },
        setDataRiconsegnaBagaglio:(state,value)=>{
            state.datariconsegnabagaglio = value;
        },
        setDataComunicazione:(state,value)=>{
            state.datacomunicazionecompagnia = value;
        },
        setNessunaComunicazione:(state,value)=>{
            state.nessunacomunicazione = value;
        },
        setBagaglioNonRiconsegnato:(state,value)=>{
          state.bagagliononriconsegnato = value;
        },
        setDataRiprotezione: ( state,value)=>{
            state.datariprotezione = value;
        },
        pulisciStato:(state)=>{
            state.numerovolo = null;
            state.informazioni = '';
                state.partenza = null;
                state.destinazione = null;
            state.coincidenze= [];
                state.coincidenzepresenti = false;
                state.datavolo = false;
                state.tipoproblema = null;
                state.compagnia = null;
                state.datacomunicazionecompagnia = null;
                state.datariconsegnabagaglio = null;
                state.bagagliononriconsegnato = false;
                state.nessunacomunicazione = false;
                state.datariprotezione = null
        }
    }
}